import { h } from 'preact';
import Router from "preact-router";
import { route } from "preact-router";
import { useState, useContext  } from 'preact/hooks';
import { useStripe, useElements, PaymentElement, CardElement  } from '@stripe/react-stripe-js';
import { Text, withText } from "preact-i18n";
import  StripeError  from '../stripe-error/StripeError';
// API
import { StripeService } from "elc-internal-api";

// Style
import styles from "./style.scss";
import { PrimaryButton } from "elc-button";
import  Loading  from "elc-loading";

const PaymentForm = (props, {cardHolderNamePlaceholder}) => {

  const stripe = useStripe();
  const elements = useElements();
  const [clientSecret, setClientSecret] = useState('');
  const [loading, setLoading] = useState(false);
  const [complete, setComplete] = useState(false);
  const [error, setError] = useState(null);
  const [name, setName] = useState('');

  //console.log('Props:', props);

  const handleChange = async (event) => {
    //console.log("event", event)
    if (event.complete) {
      setLoading(false);
      setComplete(true)
    } else{
      setComplete(false)
    }
  }

    // stop loading and show error component
    const handleStripeError = (res) => {
      //console.log('handleStripeError(res)', res)
      if(res.error){
        setError(res.error);
        setLoading(false);
      } else if(res.stringCode) {
        route(`/stripe/error/${res.stringCode}`);
      } else{
        route(`/stripe/error/500`);
        return
      }

    };

  const handleInputChange = (event) => {
    setName(event.target.value)
    //console.log('event', event.target.value)
  }

  const handleSubmit = async (event) => {
       event.preventDefault();
    setLoading(true);
    setError(null);


    if(props.checkSession(props.order)){

      if (!stripe || !elements) {
        setError('Stripe has not loaded correctly.');
        setLoading(false);
        return;
      }

      const { error: submitError } = await elements.submit();
      if (submitError) {
        setError(submitError.message);
        return;
      }

      //console.log("elements.getElement(PaymentElement)", elements.getElement(PaymentElement))
      const result  =  await stripe
      .createPaymentMethod({
        elements,
        params: {
          billing_details: {
            name : name,
            address: {
                          line1: null,
                          line2: null,
                          city: null,
                          state: null,
                          postal_code: null,
                          country: null, // Spécifiez le pays ici
                        }
          },
        },
      });
      if (result.error) {
        setError(result.error);
      } else {
        // console.log('result', result)
        // console.log('props.paymentMethod------------------------------------------------------', props.paymentMethod.configuration.deposit === 100  ? false : true)

        StripeService.validateCommissions(
          {
            order: props.order,
            paymentMethod: props.paymentMethod,
            stripePaymentMethod : result.paymentMethod,
            pi : props.pi,
            downPayment : props.paymentMethod.configuration.deposit === 100  ? false : true
          },
          (res, err) => {
            if (err || !res) {
              console.log(err);
              return;
            }
           // console.log('res - chargePaymentMethod - true:', res);

            if(res == true) {
            //appel confirmation de paiement - A tester avec un produit a
            stripe.confirmPayment({
              elements,
              confirmParams: {
                return_url: 'http://localhost:3000/success'
              },
              redirect: 'if_required',
            })
              .then((response) => {
                // console.log('props', props)
                // console.log('res confirmPayment', response)

                // console.log('res.paymentIntent.id', response.paymentIntent.id)
                if(response.error){
                  handleStripeError(response)
                  //setError(response.error);
                  //setLoading(false);
                  // console.log('err confirmPayment', response.error)
                } else{
                  // props.setPaymentMethod(props.paymentMethod, {
                  //   charge: res
                  // });
                  StripeService.chargeConfirm(
                    {
                      id: response.paymentIntent.id,
                    },
                    (res, err) => {
                      if (err || !res.paymentSuccess) {
                        handleStripeError(res)
                      } else {
                        // console.log("res", res)
                        // console.log("responsewwwwwwwwwwwwww", response)
                        // Show success message
                        props.setPaymentMethod(props.paymentMethod, {
                          charge: res
                        });
                      }
                    }
                  );
                }


              })
              .catch((err) => console.error('Error fetching payment intent:', err));

            }
            if (res.stringCode) {
              setError(res.stringCode);
            }
          });

      }
    }










  };

  const options = {
                    fields: {
                        billingDetails: {
                          address: 'never',
                          name: 'never'
                         }
                    }
                 };

  return (
    <form onSubmit={handleSubmit}>
        {ENV != "production" && (
          <div class={styles.cardNumberInfos}>
            <Text id="payment.creditCard.cardNumberTest">Card number :</Text>{" "}
            <strong>4000 0025 0000 0003</strong> <br />
            <Text id="payment.creditCard.cardDateValidTest">
              Utilisez une date d’expiration valide telle que
            </Text>{" "}
            <strong>12/34</strong>
            <br />
            <Text id="payment.creditCard.cardCvcTest">
              Utilisez n’importe quel code CVC à trois chiffres
            </Text>
          </div>
        )}
     <PaymentElement  options={options} onChange={handleChange}/>
     <div class={styles.row}>
          <div class={styles.inputField}>
            <label>
              <span class={styles.inputLabel}>
                <Text id="payment.creditCard.cardHolderName.label">
                  Card holders name
                </Text>
              </span>
              <div>
              <input
              type="text"
              value={name}
              class={`${styles.stripeElement} ${styles.inputElement}`}
              onChange={handleInputChange}
              name="cardHolderName"
              placeholder={cardHolderNamePlaceholder}
              required
              />
              </div>
            </label>
          </div>
          </div>
          {/* {cardBrand && <div>Marque de la carte : {cardBrand}</div>} */}

     <div class={styles.footerButton}>
      <PrimaryButton type="submit" disabled={!stripe || loading || !complete}>
      {loading ? (
              <Loading color="#fff" />
            ) : (
              <Text id="payment.creditCard.pay">Pay</Text>
            )}
      </PrimaryButton>
      </div>
      {!error && (
          <div class={styles.footerExplanation}>
            <p>
              <Text id="payment.creditCard.pleaseWait">Please wait...</Text>
            </p>
            <p>
              <Text id="payment.creditCard.doNotRefresh">Do not refresh</Text>
            </p>
          </div>
        )}
      {error && <StripeError code={error.code} message={error.message} />}

    </form>
  );
};
export default withText({
  cardHolderNamePlaceholder: 'payment.creditCard.cardHolderName.placeholder'
})(PaymentForm);
